import request from 'helpers/request';
import api from 'config';

// 마케팅 정보활용 동의
export const MarketingAgree = (params) =>
  request({
    method: 'post',
    url: `${api.config.companyAPI}/marketing/v1/agree`,
    data: params
  });

// 마케팅 정보활용 동의 여부
export const MarketingAgreeCheck = (params) =>
  request({
    url: `${api.config.companyAPI}/marketing/v1/agree`,
    params
  });
